"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASK_TYPE = exports.STATUS = void 0;
exports.STATUS = {
    submitted: "Awaiting Approval",
    todo: "To do",
    started: "Started",
    awaiting_approval: "Awaiting Approval",
    overdue: "Overdue",
    rejected: "Rejected",
    done: "Done"
};
exports.TASK_TYPE = {
    dd: "Digital Document",
    form: "Form",
    scan: "Scan"
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFzay5jb25zdGFudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbnN0YW50L3Rhc2suY29uc3RhbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxNQUFNLEdBQUc7SUFDbEIsU0FBUyxFQUFFLG1CQUFtQjtJQUM5QixJQUFJLEVBQUUsT0FBTztJQUNiLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxPQUFPLEVBQUUsU0FBUztJQUNsQixRQUFRLEVBQUUsVUFBVTtJQUNwQixJQUFJLEVBQUUsTUFBTTtDQUNmLENBQUE7QUFFWSxRQUFBLFNBQVMsR0FBRztJQUNyQixFQUFFLEVBQUUsa0JBQWtCO0lBQ3RCLElBQUksRUFBRSxNQUFNO0lBQ1osSUFBSSxFQUFFLE1BQU07Q0FDZixDQUFBIn0=